import styles from "@/styles/modules/components/freeText.module.scss";

interface FreeTextProps {
  content: string | null;
}

export default function FreeText({ content }: FreeTextProps) {
  if (!content) return null;

  return (
    <div
      className={styles.freeText}
      dangerouslySetInnerHTML={{ __html: content }}
      data-aos="fade-in"
      data-aos-delay="300"
    />
  );
}
